export default "__VITE_ASSET__ClA0L2wB__"